"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *  A react component to display disclosure and license for agent and agency
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.userType agent or agency
 * @param {object} props.id modal id
 * @param {object} props.label modal title to display
 * @param {object} props.disclosureContent Disclosure content
 * @param {object} props.licenseContent liceses and content
 * @param {object} props.disclaimerContent disclaimer, only available for agents
 *
 * @returns {React.ReactElement} disclosure modal
 */
function DisclosureModal(props) {
  if (!props) {
    return null;
  }
  var [show, setShowModal] = (0, _react.useState)(false);
  var handleModalShow = () => OnModalShow();
  var handleModalHide = () => OnModalClose();
  var handleModalClose = () => OnModalClose();
  var OnModalShow = () => {
    setShowModal(true);
  };
  var OnModalClose = () => {
    setShowModal(false);
  };
  var GetDisclosure = () => {
    if (!(0, _lodash.isEmpty)(props.disclosureContent)) return (0, _richTextField.parseHTML)(props.disclosureContent);else return null;
  };
  var GetLicenses = () => {
    var licenses = props.licenseContent;
    if (licenses && licenses.length > 0) {
      return (0, _lodash.map)(licenses, (licenseContent, index) => {
        return /*#__PURE__*/_react.default.createElement("section", {
          key: "lic".concat(index)
        }, !(0, _lodash.isEmpty)(licenseContent.title) && /*#__PURE__*/_react.default.createElement("h4", null, (0, _richTextField.parseHTML)(licenseContent.title)), /*#__PURE__*/_react.default.createElement("p", null, !(0, _lodash.isEmpty)(licenseContent.tagline) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _richTextField.parseHTML)(licenseContent.tagline), /*#__PURE__*/_react.default.createElement("br", null)), !(0, _lodash.isEmpty)(licenseContent.content) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _richTextField.parseHTML)(licenseContent.content))));
      });
    } else return null;
  };
  var GetDisclosureAndLicenses = () => {
    if (props.userType === 'agent') {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GetDisclosure, null), /*#__PURE__*/_react.default.createElement(GetLicenses, null), props.disclaimerContent && !(0, _lodash.isEmpty)(props.disclaimerContent) && (0, _richTextField.parseHTML)(props.disclaimerContent));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GetLicenses, null), /*#__PURE__*/_react.default.createElement(GetDisclosure, null));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'inline',
    label: props.label,
    dataId: 'modal-disclosures',
    onClick: () => handleModalShow()
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show,
    onHide: handleModalHide,
    centered: true,
    contentClassName: 'default',
    title: 'Licenses and Disclosures',
    id: 'modal-disclosures'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    title: 'Licenses and Disclosures',
    onClose: () => handleModalClose()
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(GetDisclosureAndLicenses, null))));
}
var _default = exports.default = DisclosureModal;